<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Star Micronics receipt printer</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="update()" *ngIf="receipt_printers && receipt_printers.length != 0">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="receipt_printers && receipt_printers.length != 0" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="selectOptions" label="Model" labelPlacement="stacked" fill="outline" (ionCancel)="clearReceiptPrinterModel()" (ngModelChange)="displayTestButton()" [(ngModel)]="receipt_printer['model']">
                                <ion-select-option *ngFor="let printer of receipt_printers" value="{{printer.model}}">{{printer.model}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="20" label="Port" labelPlacement="stacked" fill="outline" (ngModelChange)="displayTestButton()" [(ngModel)]="receipt_printer['port']">
                                <fa-icon [icon]="['fal', 'search']" size="lg" [fixedWidth]="true" class="search-icon" slot="end" (click)="presentFindPrinterModal()"></fa-icon>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select  cancelText="Cancel" okText="OK" interface="alert" label="Paper width" labelPlacement="stacked" fill="outline" (ngModelChange)="displayTestButton()" [(ngModel)]="receipt_printer['paper_width']">
                                <ion-select-option value="384">58mm (2")</ion-select-option>
                                <ion-select-option value="576">80mm (3")</ion-select-option>
                                <ion-select-option value="832">112mm (4")</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>

<ion-footer *ngIf="show_test_printer_button == true" class="ion-no-border">
    <ion-list>
        <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="testPrint()">
            <ion-label>TEST PRINTER</ion-label>
        </ion-item>
    </ion-list>
</ion-footer>